var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"theme-btn",class:("btn-" + _vm.btnTheme),attrs:{"text":"","block":""},on:{"click":_vm.clickBtn}},[(_vm.btnIcon)?_c('span',[_c('img',{attrs:{"src":_vm.btnIcon}})]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.btnText))])])}
var staticRenderFns = []

export { render, staticRenderFns }